import { supabase } from '@/lib/supabase';
import type { Receipt } from '@/types';

export interface CreateReceiptInput {
  projectId: string;
  projectName: string;
  receiptDate: string;
  concept: string;
  description: string | null;
  amount: number;
  observation: string | null;
  createIncome: boolean;
  incomeCategory: string;
  createdBy: string | null;
  createdByName: string;
}

/** Crea un recibo y, opcionalmente, su movimiento de ingreso asociado en Finanzas. */
export async function createReceipt(input: CreateReceiptInput): Promise<Receipt> {
  const { data, error } = await supabase
    .from('receipts')
    .insert({
      project_id: input.projectId,
      receipt_date: input.receiptDate,
      concept: input.concept,
      description: input.description?.trim() || null,
      amount: input.amount,
      observation: input.observation?.trim() || null,
      created_by: input.createdBy,
      created_by_name: input.createdByName,
    })
    .select('*, projects(*, clients(*))')
    .maybeSingle();

  if (error) throw error;
  const receipt = data as Receipt;

  if (input.createIncome && receipt) {
    await supabase.from('financial_movements').insert({
      movement_type: 'INGRESO',
      movement_date: input.receiptDate,
      category: input.incomeCategory,
      concept: `${input.concept} — ${input.projectName}`,
      amount: input.amount,
      receipt_id: receipt.id,
      project_id: input.projectId,
      created_by: input.createdBy,
      created_by_name: input.createdByName,
    });
  }

  return receipt;
}

export async function deleteReceipt(receiptId: string): Promise<void> {
  const { error } = await supabase.from('receipts').delete().eq('id', receiptId);
  if (error) throw error;
}